export const constants={
    IMG_URL:"http://www.kantmanufaktur.com/themes/mauer/images/products/"
}
